import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { message as toaster, Button, Modal } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { Flex, Text, Box } from 'atoms';
// import { searchPastInvoice, clearPastInvoiceState, getInvoices } from 'store/invoiceSlice';
import { Search } from './Collection.style';
import {
	clearPastInvoiceState,
	getSalesInvoicesList,
	searchPastInvoice,
} from 'store/salesmanSlice';

const FinishBtn = styled(Button)`
	width: 180px;
	height: 40px;
	padding: 0;
	border-radius: 4px;
	background-color: ${(props) => props.theme.colors.primary};
	font-size: 12px;
	line-height: 40px;
`;

const SearchContainer = styled.div`
	padding: 50px;

	button {
		display: block;
		margin: 0 auto;
		width: 80%;
	}
`;
const SearchField = styled(Search)`
	width: 100%;
	border: ${(props) => (!props.pastInvoiceState ? '1px solid #FF5656' : '1px solid #000000')};
	background-color: #fff;
	font-weight: 600;
	color: ${(props) => (!props.pastInvoiceState ? 'red' : '#000')};
	border-radius: 4px;

	::placeholder,
	::-ms-input-placeholder {
		color: #000;
	}
`;

const ClearContainer = styled.div`
	button {
		border: 1px solid ${(props) => props.theme.colors.primary};
		background: #fff;
		color: ${(props) => props.theme.colors.primary};
		cursor: pointer;
	}
`;

const Cleartext = styled.div`
	font-size: 10px;
	font-weight: 600;
`;

export default function AddInvoices() {
	const [showAddInvoice, setShowAddInvoice] = useState(false);
	const [search, setSearch] = useState('');
	const dispatch = useDispatch();
	const { pastInvoiceState, SalesInvoices, can_salesman_edit, SalesRejectedInvoices } =
		useSelector((state) => state.salesman);
	const { invoiceDate } = useSelector((state) => state.app);

	console.log(SalesInvoices, 'SalesInvoices');

	const checksegregatorVerified = (value) =>
		value.verified_by_segregator_at === null || value.verified_by_segregator_at === 'null';
	const segregatorVerified = SalesInvoices.some(checksegregatorVerified);

	console.log(segregatorVerified, 'segregatorVerified');

	useEffect(() => {
		dispatch(clearPastInvoiceState());
	}, [dispatch]);

	const handleInput = (value) => {
		setSearch(value);

		if (!pastInvoiceState) {
			dispatch(clearPastInvoiceState());
		}
	};

	const handleClear = () => {
		setSearch('');
		dispatch(clearPastInvoiceState());
	};

	const handleClose = () => {
		setSearch('');
		setShowAddInvoice(false);
		dispatch(clearPastInvoiceState());
		dispatch(getSalesInvoicesList());
	};

	const handleSearch = () => {
		/**
		 * After added valid invoice clear the search box
		 */
		dispatch(searchPastInvoice(search)).then(({ data }) => {
			if (data?.length > 0) {
				dispatch(getSalesInvoicesList());
				toaster.success('Invoice Added success');
				handleClose();
			}
		});
	};

	const handleAddInvoice = () => {
		/**
		 * No need to check this condition for add new invoice, 23-11-2022, Praveen told to remove this logic,
		 * so always show the add new invoice popup.
		 */
		// dispatch(getInvoices()).then((res) => {
		// 	if (res?.data?.some(checksegregatorVerified)) setShowAddInvoice(true);
		// 	else toaster.error('Salesman Verification Done');
		// });
		setShowAddInvoice(true);
	};

	const getDisablecCheck = () => {
		if (SalesInvoices.length === 0) {
			if (SalesRejectedInvoices.length > 0) {
				return true;
			}

			return false;
		}
		if (can_salesman_edit) {
			return false;
		}

		return true;
	};

	return (
		<>
			{moment(invoiceDate).isSame(Date.now(), 'day') && (
				<Flex justifyContent="center" alignItems="center" mb="1rem">
					{(segregatorVerified || SalesInvoices.length === 0) && (
						<FinishBtn
							disabled={getDisablecCheck()}
							onClick={handleAddInvoice}
							type="primary"
						>
							Add New Invoice
						</FinishBtn>
					)}
				</Flex>
			)}

			{/* Add invoice modal */}
			<Modal
				className="search__invoice"
				title={null}
				footer={null}
				visible={showAddInvoice}
				width={360}
				onCancel={handleClose}
				maskClosable={false}
			>
				<SearchContainer>
					<Box mt={4}>
						<Text fontSize="14px">Invoice Number</Text>
					</Box>
					<Box mt={2}>
						<SearchField
							pastInvoiceState={pastInvoiceState}
							value={search}
							onChange={(e) => handleInput(e.target.value)}
						/>

						{pastInvoiceState && (
							<Box mt={3}>
								<Button
									onClick={handleSearch}
									disabled={search === ''}
									size="large"
									type="primary"
								>
									Add Invoice
								</Button>
							</Box>
						)}
					</Box>

					{!pastInvoiceState && (
						<ClearContainer>
							<Box mt={2}>
								<Cleartext>
									Sorry, Ripplr is unable to find that invoice in the system /
									This Invoice is not belongs to you.
								</Cleartext>
							</Box>
							<Box mt={4}>
								<Button size="large" type="primary" onClick={handleClear}>
									Clear
								</Button>
							</Box>
						</ClearContainer>
					)}
				</SearchContainer>
			</Modal>
		</>
	);
}
